<nav class="navbar navbar-expand-lg navbar-transparent bg-primary navbar-absolute fixed-top" color-on-scroll="500">
  <div class="container">
    <div class="navbar-translate">
      <a class="navbar-brand" rel="tooltip" title="Designed by PetaMedia" data-placement="bottom">
        <img *ngIf="folder===''" src="assets/img/logo_petamedia_w_text.svg" class="img-fluid" style="max-height: 30px">
        <img *ngIf="folder!==''" src="assets/360/vtour/tours/{{folder}}/logo.png" class="img-fluid" style="max-height: 60px">
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-bar top-bar"></span>
        <span class="navbar-toggler-bar middle-bar"></span>
        <span class="navbar-toggler-bar bottom-bar"></span>
      </button>
    </div>
    <!--<div class="collapse navbar-collapse" data-nav-image="./assets/img//blurred-image-1.jpg" data-color="orange">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown">
          <a href="#" class="nav-link dropdown-toggle" id="projectDropdownLink" data-toggle="dropdown">
            <i class="now-ui-icons media-1_album" aria-hidden="true"></i>
            <p>Projects</p>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="projectDropdownLink">
            <a class="dropdown-item" [routerLink]="['/project/reizcondo']">
              Reiz Condo
            </a>
            <a class="dropdown-item" [routerLink]="['/project/padanggolf']">
              Padang Golf
            </a>
            <a class="dropdown-item" [routerLink]="['/project/mutiararesidence']">
              Mutiara Residence
            </a>
            <a class="dropdown-item" [routerLink]="['/project/masdulhak']">
              Masdulhak
            </a>
            <a class="dropdown-item" [routerLink]="['/project/royalsumatra']">
              Royal Sumatra
            </a>
          </div>
        </li>
        <li class="nav-item dropdown">
          <a href="#" class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown">
            <i class="now-ui-icons design_app" aria-hidden="true"></i>
            <p>Virtual Tours</p>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
            <a class="dropdown-item" [routerLink]="['/pano/1']">
              Reiz Condo 1 BR
            </a>
            <a class="dropdown-item" [routerLink]="['/pano/2']">
              Reiz Condo 2 BR
            </a>
            <a class="dropdown-item" [routerLink]="['/pano/3']">
              Reiz Condo 1 BR - MultiResolution
            </a>
            <a class="dropdown-item" [routerLink]="['/pano/4']">
              Kenanga Palace
            </a>
            <a class="dropdown-item" [routerLink]="['/pano/5']">
              Royal Sumatra
            </a>
          </div>
        </li>
        &lt;!&ndash;<li class="nav-item">
          <a class="nav-link btn btn-primary" href="https://www.creative-tim.com/product/now-ui-kit-pro" target="_blank">
            <p>Buy Now</p>
          </a>
        </li>&ndash;&gt;
      </ul>
    </div>-->
  </div>
</nav>
